import request from '@/utils/request';

export function VIPmanagementAPI() {
  return {
    // 列表
    VIPmanagementList: params => {
      return request({
        url: '/admin/auth/vip/index',
        method: 'get',
        params,
      });
    },
    // 角色组
    roleList: params => {
      return request({
        url: '/admin/role/index',
        method: 'get',
        params,
      });
    },
     // 小程序名称列表
     applicationList: params => {
      return request({
        url: '/admin/microapp/index',
        method: 'get',
        params,
      });
    },
    //新增
    VIPAdded: data => {
      return request({
        url: '/admin/auth/vip/update',
        method: 'post',
        data
      });
    },
    VIPAdd: data => {
      return request({
        url: '/admin/auth/vip/store',
        method: 'post',
        data
      });
    },
      // 详情数据
      detailsList: params => {
        return request({
          url: `/admin/auth/vip/show?id=${params}`,
          method: 'get',
        });
      },
  };
}
